import { DoorOpeningDirectionComponent, EventComponent, PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import { DoorNextToCornerSolutionComponent } from '../..';
import DoorsNextToCornerSolutionComponent from '../components/DoorNextToCornerSolutionComponent';
/**
 * This system changes door opening direction of doors next to corner solution so handles face away from the corner
 * (to avoid damaging the doors on the corner solution that can open up almost 180 degrees)
 */
export class DoorsNextToCornerSolutionSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'DoorsNextToCornerSolutionSystem', EventComponent.id);
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.event === 'history') {
            const doorsPreviouslyNextToCornerSolution = this.coreApi.entities.getByComponent(DoorNextToCornerSolutionComponent.id);
            doorsPreviouslyNextToCornerSolution.forEach(door => door.removeComponent(DoorNextToCornerSolutionComponent.id));
            const cornerSolutionsWithDoors = this.coreApi.entities
                .getByComponent(CornerSolutionComponent.id)
                .filter(cornerSolution => HierarchyUtils.getDescendantsWithComponent(cornerSolution, ComponentIds.DOOR_COMPONENT_ID).length > 0);
            if (cornerSolutionsWithDoors.length === 0)
                return;
            const framesInCornerSolutions = cornerSolutionsWithDoors.flatMap(cornerSolution => HierarchyUtils.descendants(cornerSolution).filter(e => e.hasComponent(ComponentIds.FRAME_COMPONENT_ID)));
            const framesNextToCornerSolution = framesInCornerSolutions.flatMap(frame => this.coreApi.entities.getAlignedFrames(frame, 'align-left', 'align-right', true, true));
            const leftDoors = this.getAllDoorsOnAdjacentFrames(framesNextToCornerSolution, 'left');
            const rightDoors = this.getAllDoorsOnAdjacentFrames(framesNextToCornerSolution, 'right');
            leftDoors.forEach(door => {
                this.changeDoorOpeningDirection(door, 'attach-frame-rotated', 'right-door-placement');
            });
            rightDoors.forEach(door => {
                this.changeDoorOpeningDirection(door, 'attach-frame', 'left-door-placement');
            });
        }
    }
    onRemove() { }
    getAllDoorsOnAdjacentFrames(frames, position) {
        const adjacentFrames = frames.map(frame => frame[position]).filter(Boolean);
        const doors = adjacentFrames
            .map(frame => {
            return this.coreApi.entities.getEntityComSize(frame)?.width === 500
                ? HierarchyUtils.getDescendantWithComponent(frame, ComponentIds.DOOR_COMPONENT_ID)
                : null;
        })
            .filter(Boolean);
        return doors;
    }
    changeDoorOpeningDirection(door, doorConnectorKey, frameConnectorKey) {
        const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(door, ComponentIds.FRAME_COMPONENT_ID);
        const openingDirectionData = frame?.getComponent(DoorOpeningDirectionComponent.id);
        if (openingDirectionData && frame) {
            openingDirectionData.doorFrameConnectorKeys = [frameConnectorKey];
            this.coreApi.placementService.snapToConnector(door, doorConnectorKey, frame, frameConnectorKey);
            door.addComponent(new DoorsNextToCornerSolutionComponent());
        }
    }
}
//# sourceMappingURL=DoorsNextToCornerSolutionSystem.js.map